const Card = ({ children, className = '', hover = false, padding = true, ...props }) => {
  return (
    <div
      className={`card ${padding ? 'card-padding' : ''} ${hover ? 'card-hover' : ''} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

export const StatCard = ({ label, value, icon, trend, trendLabel }) => {
  return (
    <Card>
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-slate-500 dark:text-slate-400">{label}</p>
          <p className="mt-1 text-2xl font-semibold text-slate-900 dark:text-slate-100 tabular-nums">
            {value}
          </p>
          {trend !== undefined && (
            <p
              className={`mt-1 text-xs font-medium ${trend >= 0 ? 'text-accent-600 dark:text-accent-300' : 'text-danger-600 dark:text-danger-300'}`}
            >
              {trend >= 0 ? '↑' : '↓'} {Math.abs(trend)}%{trendLabel && ` ${trendLabel}`}
            </p>
          )}
        </div>
        {icon && (
          <div className="w-10 h-10 rounded-lg bg-primary-50 dark:bg-primary-950/50 flex items-center justify-center text-primary-600 dark:text-primary-300 flex-shrink-0">
            {icon}
          </div>
        )}
      </div>
    </Card>
  );
};

export default Card;
